module.exports = __webpack_public_path__ + "static/media/live-btn79037890150473929b4c794a34e1db93.webp";